import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import StyledReactButton from 'components/Buttons/StyledButton';
import { store } from 'redux/store';
import { authActions } from 'redux/auth';
import { get } from 'api/User/self';

const Maintenance: React.FC = () => {
  const { t } = useTranslation('maintenance');

  const getUsersSelf = () => {
    get(
      () => {
        store.dispatch(authActions.logout(true));
      },
      () => {
        window.location.reload();
      }
    );
  };

  document.title = t('title');
  return (
    <Container>
      <TextTop>
        <TopSpan>{t('textTop')}</TopSpan>
      </TextTop>
      <TextBody>
        <span>
          {t('textBody1')}
          <br />
          {t('textBody2')}
        </span>
      </TextBody>
      <StyledReactButton color="primary" onClick={getUsersSelf}>
        {t('back')}
      </StyledReactButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

const TextTop = styled.div`
  margin-bottom: 50px;
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
  font-size: 49px;
  font-style: normal;
`;

const TopSpan = styled.span`
  border-bottom: solid 1px #707070;
`;

const TextBody = styled.div`
  margin-top: -9px;
  margin-bottom: 40px;
  color: rgba(0, 0, 0, 1);
  font-weight: normal;
  font-size: 23px;
  font-style: normal;
  line-height: 41px;
  white-space: nowrap;
  text-align: center;
`;

export default Maintenance;
